import { useCallback, type MouseEvent } from 'react'

import { useNavigate } from 'react-router-dom'
import { Routes } from 'common/constants'
import { logBridgeError, sendSelectContent } from 'common/helpers'
import { useAppContext } from 'contexts/app-context/hooks/useAppContext'

export function useManageNotificationsProductNavTic(productKey: string) {
  const navigate = useNavigate()
  const { userSelectedEntity } = useAppContext()

  return useCallback(
    async (event?: MouseEvent<HTMLAnchorElement>) => {
      event?.preventDefault()

      try {
        await sendSelectContent({
          flow: 'manage_notifications',
          step: 'notifications_management',
          screen_name: Routes.NOTIFICATIONS_MANAGEMENT,
          element_name: 'selectProductCard',
          element_type: 'button',
          parent_name: 'ManageNotifications',
          scenario: JSON.stringify({
            screen: Routes.NOTIFICATIONS_MANAGEMENT,
            product: userSelectedEntity,
            productKey,
            ref_type: 'button',
            content_action: 'touch',
          }),
        })
      } catch (error: unknown) {
        logBridgeError('send manage notifications product nav tic', error)
      }

      navigate(productKey, { relative: 'path' })
    },
    [navigate, productKey, userSelectedEntity],
  )
}
